import React from 'react';
import StarBorder from './StarBorder';

const Transportes = () => {
    const trucks = [
        {
            id: 1,
            name: "Volvo FH16 750S",
            capacity: "25 toneladas",
            year: 2021,
            description: "Camión articulado de última generación con tecnología de punta para transporte de carga pesada."
        },
        {
            id: 2,
            name: "Scania R440",
            capacity: "20 toneladas",
            year: 2019,
            description: "Vehículo versátil ideal para distribución regional y transporte de carga general."
        },
        {
            id: 3,
            name: "Mercedes-Benz Actros 2663",
            capacity: "18 toneladas",
            year: 2020,
            description: "Camión especializado en transporte urbano y rutas cortas con máxima seguridad."
        }
    ];

    return (
        <main>
            <section className="transportes-section py-5">
                <div className="container">
                    <div className="text-center mb-5">
                        <h1 className="display-4 fw-bold mb-3">BMC Transportes</h1>
                        <p className="lead text-muted">Soluciones logísticas profesionales y confiables</p>
                    </div>

                    <div className="row mb-5">
                        <div className="col-lg-8 mx-auto">
                            <div className="card border-0 shadow-none">
                                <div className="card-body p-4">
                                    <h3 className="card-title mb-3 text-white">Sobre nuestros servicios</h3>
                                    <p className="card-text mb-3 text-white-50">
                                        BMC Transportes es la división de logística y transporte de BMC, especializada en soluciones de carga y distribución con altos estándares de calidad y seguridad.
                                    </p>
                                    <p className="card-text mb-3 text-white">
                                        <strong>Servicios principales</strong>
                                    </p>
                                    <ul className="list-unstyled text-white-50">
                                        <li className="mb-2">✓ Transporte de carga pesada</li>
                                        <li className="mb-2">✓ Distribución regional y nacional</li>
                                        <li className="mb-2">✓ Logística integrada</li>
                                        <li className="mb-2">✓ Transporte especializado</li>
                                    </ul>
                                    <p className="card-text mt-3 mb-0 text-white-50">
                                        <strong className="text-white">Años de experiencia:</strong>{' '}
                                        <span className="badge bg-primary">15+ años</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 mb-4">
                            <h2 className="text-center mb-4 fw-bold">Nuestra Flota</h2>
                        </div>
                        {trucks.map((truck) => (
                            <div key={truck.id} className="col-md-6 col-lg-4 mb-4">
                                <div className="card h-100 border-0 shadow-none">
                                    <div className="card-body">
                                        <h5 className="card-title text-primary fw-bold">{truck.name}</h5>
                                        <p className="card-text text-muted small mb-2">
                                            <strong className="text-white">Capacidad:</strong> {truck.capacity}
                                        </p>
                                        <p className="card-text text-muted small mb-2">
                                            <strong className="text-white">Año:</strong> {truck.year}
                                        </p>
                                        <p className="card-text text-white-50">{truck.description}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="row mt-5">
                        <div className="col-12 text-center">
                            <StarBorder
                                as="a"
                                href="/contact"
                                className="d-inline-block"
                                innerClassName="btn btn-primary btn-lg"
                                color="rgba(126, 189, 203, 0.4)"
                                speed="10s"
                            >
                                Solicitar Servicio
                            </StarBorder>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default Transportes;
